export async function fetchCompaniesByRegionId(regionId) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Company/ByRegion?regionId=${regionId}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      return null;
    }
    console.error("Erreur lors de la récupération des compagnies", error);
    throw error;
  }
}

export async function fetchCompanyById(userId) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Company?userId=${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const responseText = await response.text();

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Si la réponse est vide, retourner null
    if (responseText.trim() === "") {
      return null;
    }

    // Si la réponse n'est pas vide, la convertir en JSON
    return JSON.parse(responseText);
  } catch (error) {
    if (error.name === "AbortError") {
      return null;
    }
    console.error("Erreur lors de la récupération de la compagnie", error);
    throw error;
  }
}

export async function addOrUpdateCompany(companyData) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Company`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(companyData), // Conversion des données en JSON
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Erreur lors de l'ajout de la compagnie", error);
    throw error;
  }
}

export async function addOrUpdateCompanies(companies) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Company/Batch`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(companies),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json(); // optionnel si tu veux retourner les IDs
  } catch (error) {
    console.error("Erreur lors de l'enregistrement des compagnies", error);
    throw error;
  }
}

export async function fetchCompaniesByUserId(userId) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Company?userId=${userId}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Erreur lors de la récupération des compagnies :", error);
    return [];
  }
}

export async function getServicesByCompanyId(companyId) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Services/ByCompany?companyId=${companyId}`
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Erreur lors de la récupération des services :", error);
    return [];
  }
}

export async function fetchAllActiveCompanies() {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Company/All/ActiveOnly`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      return null;
    }
    console.error(
      "Erreur lors de la récupération des compagnies actives",
      error
    );
    throw error;
  }
}
